import { render, staticRenderFns } from "./WspModal.vue?vue&type=template&id=2eac2247"
import script from "./WspModal.vue?vue&type=script&lang=js"
export * from "./WspModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports